import React, { memo } from 'react';
import { View } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import { Text, Space } from '@redlink/components/atoms';
import { ListItem } from '@redlink/components/molecules';

export const AchievementItem = memo(
  ({
    item: { id, title, where, date, createDate, isVisible } = {},
    onEditPressed,
    onChangeAvailability,
    onDelete,
    dragHandle,
    dragable,
  }) => {
    const { styles } = useStyle();

    return (
      <ListItem
        variant="minimal"
        {...{
          onEditPressed,
          onChangeAvailability,
          onDelete,
          isVisible,
          dragHandle,
          dragable,
        }}
      >
        <View>
          <Text style={styles.titleText}>{title}</Text>
          <Space size={8} />
          <Text style={styles.subtitleText}>{where}</Text>
          <Text style={styles.subtitleText}>{date}</Text>
        </View>
      </ListItem>
    );
  }
);

const useStyle = createUseStyle(({ colors, size, shadow }) => ({
  titleText: {
    fontWeight: 'bold',
    fontSize: 16,
    color: colors.gray23,
    textAlign: 'left',
  },
  subtitleText: {
    fontSize: 12,
    color: colors.gray23,
    textAlign: 'left',
  },
}));
